import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../styles/components/common/ToggleSwitch.css';
import { FaSpinner } from 'react-icons/fa';
import Popup from './popup/Popup';

const ToggleSwitch = ({ id, checked, onChange, disabled, loading, leftLabel = 'Private', rightLabel = 'Public', confirmTitle, confirmMessage }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const handleClick = () => {
    if (disabled) return;
    if (!checked && confirmTitle && confirmMessage) {
      setShowConfirm(true);
    } else {
      onChange(!checked);
    }
  };
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!checked && confirmTitle && confirmMessage) {
        setShowConfirm(true);
      } else {
        onChange(!checked);
      }
    }
  };
  const confirmHandler = () => {
    onChange(true);
    setShowConfirm(false);
  };
  const cancelHandler = () => {
    setShowConfirm(false);
  };
  return (
    <>
      <button
        id={id}
        type="button"
        className={`toggle-switch ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        aria-pressed={checked}
        disabled={disabled}
      >
        <span className="toggle-slider" />
        <span className="toggle-label left">{leftLabel}</span>
        <span className="toggle-label right">{rightLabel}</span>
        {loading && (
          <span className="spinner-container">
            <FaSpinner className="toggle-spinner" />
          </span>
        )}
      </button>
      {showConfirm && (
        <Popup
          title={confirmTitle}
          message={confirmMessage}
          onConfirm={confirmHandler}
          onCancel={cancelHandler}
        />
      )}
    </>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
};

export default ToggleSwitch;
